import React from "react";
import { 
  FaQuoteLeft, 
  FaQuoteRight, 
  FaArrowRight, 
  FaGraduationCap, 
  FaTrophy,
  FaUsers,
  FaStar,
  FaEye,
  FaBullseye,
  FaHandsHelping
} from "react-icons/fa";
import { MdChair, MdVerified } from "react-icons/md"; 
const ChairmanMessageSection = () => {
  return (
    <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-green-700 to-blue-600 bg-clip-text text-transparent">
              Chairman's Message
            </span>
          </h2>
        </div>
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200">
          <div className="h-2 bg-gradient-to-r from-green-600 to-blue-600"></div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 p-8 lg:p-10">
            <div className="lg:col-span-1">
              <div className="sticky top-8">
                <div className="relative mb-6">
                  <div className="absolute -bottom-3 left-5 right-5 h-4 bg-gray-300/50 blur-sm rounded-full"></div>
                  <div className="absolute -bottom-2 left-3 right-3 h-3 bg-gray-400/30 blur-md rounded-full"></div>
                  <img 
                    src="/chairman.png" 
                    alt="Sandeep Singh, Chairman"
                    className="w-full h-auto block relative z-10 rounded-2xl"
                  />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-800">Sandeep Singh</h3>
                  <p className="text-green-600 font-medium">Chairman</p>
                  <p className="text-green-600 font-medium">RDS Group Of College</p>
                  <p className="text-sm text-gray-500 mt-1"></p>
                  <div className="mt-4 inline-flex items-center gap-1 bg-green-50 px-3 py-1.5 rounded-full">
                    <FaStar className="text-green-600 text-xs" />
                    <span className="text-xs text-green-700 font-medium">25+ Years Leadership</span>
                  </div>
                </div>
                <div className="mt-6 flex justify-center gap-2">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <FaEye className="text-green-600 text-sm" />
                  </div>
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <FaBullseye className="text-blue-600 text-sm" />
                  </div>
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <FaHandsHelping className="text-green-600 text-sm" />
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:col-span-2">
              <div className="mb-4">
                <FaQuoteLeft className="text-5xl text-green-200" />
              </div>
              <div className="space-y-6 text-gray-700">
                <p className="text-lg leading-relaxed font-medium text-gray-800">
                  "Our vision is to create a center of excellence that produces not just graduates, 
                  but leaders in healthcare who will shape the future of medicine."
                </p>
                <p className="leading-relaxed">
                  It gives me immense pride and joy to welcome you to R.D.S. NURSING & PARAMEDICAL COLLEGE. 
                  What started as a small initiative in 1998 has today grown into one of the most respected 
                  institutions for healthcare education in Eastern Uttar Pradesh. Our journey has been 
                  guided by a single principle: excellence with compassion.
                </p>
                <p className="leading-relaxed">
                  In today's rapidly evolving healthcare landscape, the role of nurses and pharmacists has 
                  become more critical than ever. At RDS, we are committed to preparing our students to meet 
                  these challenges head-on. Through our industry-integrated curriculum, state-of-the-art 
                  infrastructure, and dedicated faculty, we ensure that our students are ready to excel 
                  in any healthcare setting globally.
                </p>
                <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white p-6 rounded-xl">
                  <h4 className="font-bold text-lg mb-3 flex items-center gap-2">
                    <FaEye className="text-white" />
                    Our Future Vision
                  </h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                      <span className="text-white">•</span>
                      <span>Establish Center of Excellence in Pharmaceutical Research by 2028</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-white">•</span>
                      <span>International collaborations for student exchange programs</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-white">•</span>
                      <span>100% placement with top healthcare institutions worldwide</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-r from-green-50 to-blue-50 p-6 rounded-xl italic border-l-4 border-green-600 mt-4">
                  <FaQuoteRight className="text-2xl text-green-400 ml-auto mb-2" />
                  <p className="text-gray-700">
                    "I invite you to be part of the RDS family, where we don't just build careers – 
                    we build character, compassion, and a commitment to serve humanity."
                  </p>
                </div>
              </div>
              <div className="mt-8 flex flex-wrap items-center justify-between gap-4">
                <div>
                  <p className="font-semibold text-gray-800">Sandeep Singh</p>
                  <p className="text-sm text-gray-500">Chairman, R.D.S. NURSING & PARAMEDICAL COLLEGE</p>
                </div>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-600 to-blue-600 text-white font-medium rounded-xl hover:from-green-700 hover:to-blue-700 transition-all duration-300">
                  Read Full Message <FaArrowRight className="text-sm" />
                </button>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-4 border-t border-gray-100">
            <div className="flex flex-wrap justify-around gap-4">
              <div className="flex items-center gap-2">
                <FaTrophy className="text-green-600" />
                <span className="text-sm text-gray-700">25+ Years of Excellence</span>
              </div>
              <div className="flex items-center gap-2">
                <FaUsers className="text-blue-600" />
                <span className="text-sm text-gray-700">5000+ Alumni Worldwide</span>
              </div>
              <div className="flex items-center gap-2">
                <FaStar className="text-green-600" />
                <span className="text-sm text-gray-700">NAAC A+ Grade</span>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 bg-gradient-to-r from-green-600 to-blue-600 rounded-xl p-6 text-white text-center shadow-lg">
          <p className="text-lg font-medium italic">
            "Together, let's build a healthier tomorrow through quality education and compassionate care."
          </p>
          <p className="text-sm mt-2 opacity-90">— Sandeep Singh, Chairman</p>
        </div>
      </div>
    </section>
  );
};

export default ChairmanMessageSection;